import {utilHelper} from "./utilHelper.js";

/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 15/09/2025
 */
export const cusfieldHelper = {
    setCustomDataId(items) {
        if(Array.isArray(items) && items.length > 0) {
            items.forEach(item => {
                item.id = utilHelper.getUuid4()
                if(item.hasOwnProperty('children') && Array.isArray(item.children) && item.children.length > 0) {
                    cusfieldHelper.setCustomDataId(item.children);
                }
            });
        }
    }
}
